import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "task-list",
    on: {
      click: function ($event) {
        return _vm.$router.push("/task");
      }
    }
  }, [_c("a-tooltip", {
    attrs: {
      placement: "bottom"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("任务列表")))])]), _c("svg-icon", {
    attrs: {
      icon: "renwu",
      size: 20
    }
  })], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };